module.exports = __webpack_public_path__ + "img/btn-foldingmat@3x.8a832818.png";